import React from 'react'


const Question = (props) => <svg
    {...props}
    viewBox="0 0 32 28"
    xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
    <path
        d="M30 22H12.468l-4.7 5.64a.997.997 0 0 1-1.108.301A1.002 1.002 0 0 1 6 27v-5H2c-1.103 0-2-.897-2-2V2C0 .897.897 0 2 0h28c1.103 0 2 .897 2 2v18c0 1.103-.897 2-2 2zm0-20H2v18h5a1 1 0 0 1 1 1v3.238l3.232-3.878c.01-.012.024-.016.034-.027.049-.055.109-.094.169-.136.048-.034.09-.072.142-.096.056-.027.118-.036.18-.052.066-.017.129-.037.197-.04.016-.001.03-.009.046-.009h18V2zM16 5c2.206 0 4 1.795 4 4 0 1.858-1.28 3.41-3 3.857V13a.861.861 0 0 1-.063.31 1.067 1.067 0 0 1-.227.4 1.085 1.085 0 0 1-.399.227A.867.867 0 0 1 16 14a.861.861 0 0 1-.31-.063 1.07 1.07 0 0 1-.224-.113c-.059-.037-.125-.066-.176-.114a1.097 1.097 0 0 1-.162-.247c-.014-.027-.038-.048-.05-.077A1.008 1.008 0 0 1 15 13v-1a1 1 0 0 1 1-1c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2a1 1 0 0 1-2 0c0-2.205 1.794-4 4-4zm.71 10.29c.18.19.29.449.29.71 0 .26-.11.52-.29.71-.19.18-.45.29-.71.29-.26 0-.52-.11-.71-.29-.18-.19-.29-.44-.29-.71 0-.261.11-.52.29-.71.38-.37 1.05-.37 1.42 0z"
        fillRule="evenodd"/>
</svg>

export default Question


// WEBPACK FOOTER //
// ./src/components/_common/_icons/Question.js